import { createApp } from 'vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import store from './store'

import 'amfe-flexible'

// 导入自己UI组件库
import UI from '@/components/library'

import 'normalize.css'
import '@/assets/styles/common.less'

createApp(App).use(ElementPlus).use(store).use(router).use(UI).mount('#app')
